<div>
    <!-- TOP BUTTONS -->
    <div class="row">
        <div class="col-sm-12">
            <button type="button" class="btn fa fa-search m-2" style="background-color: #6e7dd2; color: #fff"
                (click)="filterToggle = !filterToggle">
                <span>&nbsp;Date Filter</span>
            </button>

            <button type="button" class="btn pull-right m-2" style="background-color: #6e7dd2; color: #fff"
                (click)="exportAsExcel()">
                Download CSV
            </button>
        </div>
    </div>

    <!-- DATE FILTER -->
    <mat-card class="filter col-lg-9 px-0 py-1" style="margin-top: 10px" *ngIf="filterToggle">

        <mat-card-content>
            <div class="row">
                <div class="col-sm-12">

                    <button type="button" mat-raised-button class="m-1 date-filter-btn" [ngClass]="{
                            'selected': selectedDateFilter === 'Today'
                        }" (click)="dateFilterChanged('Today')">
                        Today
                    </button>

                    <button type="button" mat-raised-button class="m-1 date-filter-btn" [ngClass]="{
                            'selected': selectedDateFilter === 'Last7Days'
                        }" (click)="dateFilterChanged('Last7Days')">
                        Last 7 days
                    </button>

                    <button type="button" mat-raised-button class="m-1 date-filter-btn" [ngClass]="{
                            'selected': selectedDateFilter === 'MTD'
                        }" (click)="dateFilterChanged('MTD')">
                        MTD
                    </button>

                    <button type="button" mat-raised-button class="m-1 date-filter-btn" [ngClass]="{
                            'selected': selectedDateFilter === 'YTD'
                        }" (click)="dateFilterChanged('YTD')">
                        YTD
                    </button>

                    <button type="button" mat-raised-button class="m-1 date-filter-btn" [ngClass]="{
                            'selected': selectedDateFilter === 'CustomDate'
                        }" (click)="openCustomDateFilter()">
                        Custom Date
                    </button>

                </div>
            </div>

            <!-- CUSTOM DATE RANGE -->
            <div class="row col-sm-12 m-2 mb-3" *ngIf="CustomDate">

                <div class="col-lg-5 m-0 p-0">
                    <div class="col-sm-2 newMarginClass">
                        From:
                    </div>

                    <div class="col-sm-8">
                        <div class="input-icon right">
                            <input class="form-control" placeholder="Select From Date" [(ngModel)]="fromDate"
                                (keydown)="inputNotAllowed()" [owlDateTimeTrigger]="fromDatePicker"
                                [owlDateTime]="fromDatePicker" name="fromDate" readonly required />

                            <owl-date-time [pickerType]="'calendar'" #fromDatePicker>
                            </owl-date-time>
                        </div>
                    </div>
                </div>

                <div class="col-lg-5 m-0 p-0">
                    <div class="col-sm-2 newMarginClass">
                        To:
                    </div>

                    <div class="col-sm-8">
                        <div class="input-icon right">
                            <input class="form-control" placeholder="Select To Date" [(ngModel)]="toDate"
                                (keydown)="inputNotAllowed()" [owlDateTimeTrigger]="toDatePicker"
                                [owlDateTime]="toDatePicker" name="toDate" readonly required />

                            <owl-date-time [pickerType]="'calendar'" #toDatePicker>
                            </owl-date-time>
                        </div>
                    </div>
                </div>

                <div class="col-lg-1 p-0 m-0">
                    <button type="button" class="add-hover btn btn-success pull-right mr-2 fa fa-search"
                        style="background-color: #6e7dd2; color: #fff" (click)="dateFilterChanged('Dates')">
                        Search
                    </button>
                </div>

                <div class="col-lg-1 p-0 m-0">
                    <button type="button" class="btn filter-hover fa fa-eraser"
                        style="background-color: #37474f; color: #fff !important" (click)="datefilterclear()">
                        Clear
                    </button>
                </div>

            </div>
        </mat-card-content>
    </mat-card>

    <div class="button-row mt-2">
        <div class="custom-segmented-group">
            <button type="button" class="segment-btn" [class.active]="SectionFilter === 'State'"
                (click)="onSectionChange({ value: 'State' })">
                State
            </button>

            <!-- <button type="button" class="segment-btn" [class.active]="SectionFilter === 'brand'"
                (click)="onSectionChange({ value: 'brand' })">
                Brand
            </button> -->
        </div>
    </div>

    <!-- SELECTED STATE -->
    <div class="d-flex align-items-center mt-2" *ngIf="SectionFilter === 'State' && selectedState">
        <span class="badge bg-primary d-flex align-items-center" style="font-size: 13px; padding: 8px 10px;">
            State: {{ selectedState }}
            <span style="color: #ff5252; cursor: pointer; margin-left: 8px;" (click)="clearSectionFilter()"
                title="Clear state filter">
                <i class="fa fa-times"></i>
            </span>
        </span>
    </div>

    <!-- SELECTED BRAND -->
    <div class="d-flex align-items-center mt-2" *ngIf="SectionFilter === 'brand' && selectedBrand">
        <span class="badge bg-primary d-flex align-items-center" style="font-size: 13px; padding: 8px 10px;">
            Brand: {{ selectedBrand }}
            <span style="color: #ff5252; cursor: pointer; margin-left: 8px;" (click)="clearSectionFilter()"
                title="Clear brand filter">
                <i class="fa fa-times"></i>
            </span>
        </span>
    </div>

    <!-- FOUR METRICS CHARTS -->
    <div class="row mt-2 align-items-stretch">

        <!-- XPCN DELAY -->
        <div class="col-12 col-md-6 col-xl-3 mb-3">
            <mat-card class="mt-2 chart-card">
                <mat-card-header class="chart-header">
                    <h4 class="chart-title">XPCN Delay
                        <span>{{ IsDelayhrsMetrix ? 'Hours' : 'Metrics' }}</span>
                        <span>{{ IsDelayhrsMetrix ? '' : '(' + Pecentages + ')' }}</span>
                    </h4>
                    <button type="button" mat-mini-fab class="chart-refresh-btn" aria-label="Reset XPCN delay chart"
                        (click)="ResetGraphMatrix('DelayMatrixGraph')">
                        <span class="fa fa-refresh"></span>
                    </button>
                </mat-card-header>

                <div class="chart-body">
                    <ngx-charts-advanced-pie-chart *ngIf="!IsDelayhrsMetrix" [scheme]="colorSchemeIntransit"
                        [results]="DelayMatrixPush" [gradient]="false"
                        (select)="onSelectGraph($event, 'DelayMatrixGraph')">
                    </ngx-charts-advanced-pie-chart>

                    <ngx-charts-advanced-pie-chart *ngIf="IsDelayhrsMetrix" [scheme]="colorSchemeHrsDelay"
                        [results]="DelayHrsMatrixPush" [gradient]="false">
                    </ngx-charts-advanced-pie-chart>
                </div>
            </mat-card>
        </div>

        <!-- SDA / NDA -->
        <div class="col-12 col-md-6 col-xl-4 mb-3">
            <mat-card class="mt-2 chart-card">
                <mat-card-header class="chart-header">
                    <h4 class="chart-title">
                        SDA ({{ SdaPecentages }}) / NDA ({{ NdaPecentages }}) Metrics
                    </h4>
                </mat-card-header>

                <div class="chart-body">
                    <ngx-charts-bar-horizontal-stacked [results]="ServiceabilityMatrixPush" [legendPosition]="'right'"
                        [yAxisLabel]="'SDA/NDA'" [legendTitle]="''" [xAxisLabel]="'Total XPCN'"
                        [scheme]="colorSchemesAppSDA" [gradient]="false" [xAxis]="true" [yAxis]="true" [legend]="true"
                        [showXAxisLabel]="true" [showYAxisLabel]="true" [showDataLabel]="true"
                        (select)="onSelectGraph($event, 'ServiceabilityGraph')">
                    </ngx-charts-bar-horizontal-stacked>
                </div>
            </mat-card>
        </div>

        <!-- STATE-WISE -->
        <!-- STATE / BRAND WISE CHART -->
        <div class="col-12 col-md-12 col-xl-5 mb-3" *ngIf="SectionFilter === 'State' || SectionFilter === 'brand'">

            <mat-card class="mt-2 chart-card">

                <mat-card-header class="chart-header">

                    <h4 class="chart-title" *ngIf="SectionFilter === 'State'">
                        Delivery By State ({{ StateListpush.length }})
                        &nbsp;|&nbsp; Total XPCN ({{ TotalStateXpcn }})
                    </h4>

                    <h4 class="chart-title" *ngIf="SectionFilter === 'brand'">
                        Delivery By Brand ({{ BrandListpush.length }})
                        &nbsp;|&nbsp; Total XPCN ({{ TotalBrandXpcn }})
                    </h4>

                    <button type="button" mat-mini-fab class="chart-refresh-btn" [disabled]="SectionFilter === 'State'
                    ? !selectedState
                    : !selectedBrand" (click)="clearSectionFilter()" aria-label="Reset chart filter">

                        <span class="fa fa-refresh"></span>

                    </button>

                </mat-card-header>

                <div class="chart-body chart-scroll">

                    <!-- STATE CHART -->
                    <div class="chart-scroll-inner" [style.min-width.px]="StateListpush.length * 60"
                        *ngIf="SectionFilter === 'State'">

                        <ngx-charts-bar-vertical [scheme]="colorScheme" [results]="StateListpush" [gradient]="false"
                            [xAxis]="true" [yAxis]="true" [legend]="false" [showXAxisLabel]="true"
                            [showYAxisLabel]="true" [yAxisLabel]="'Total XPCN'" [xAxisLabel]="'State'"
                            [showDataLabel]="true" (select)="onSelectState($event)">

                        </ngx-charts-bar-vertical>

                    </div>

                    <!-- BRAND CHART -->
                    <div class="chart-scroll-inner" [style.min-width.px]="BrandListpush.length * 60"
                        *ngIf="SectionFilter === 'brand'">

                        <ngx-charts-bar-vertical [scheme]="colorScheme" [results]="BrandListpush" [gradient]="false"
                            [xAxis]="true" [yAxis]="true" [legend]="false" [showXAxisLabel]="true"
                            [showYAxisLabel]="true" [yAxisLabel]="'Total XPCN'" [xAxisLabel]="'Brand'"
                            [showDataLabel]="true" (select)="onSelectBrand($event)">

                        </ngx-charts-bar-vertical>

                    </div>

                </div>

            </mat-card>
        </div>

        <!-- 4. APPOINTMENT METRICS -->
        <!-- <div class="col-12 col-md-6 col-xl-3 mb-3">
            <mat-card class="mt-2 h-100">


                <mat-card-header class="chart-header">
                    <h4 class="chart-title">
                        Appointment Metrics ({{ AppoinmentPercentage }})
                    </h4>
                </mat-card-header>


                <div class="w-100 flex-grow-1 scroll-class">

                    <ngx-charts-advanced-pie-chart [view]="[565, 300]" [scheme]="colorSchemesApp"
                        [results]="AppointmentMatrixPie" [gradient]="false"
                        (select)="onSelectGraph($event, 'AppointmentDelayMatrixGraph')">
                    </ngx-charts-advanced-pie-chart>

                </div>
            </mat-card>
        </div> -->


        <!-- 2. WEIGHT METRICS -->
        <!-- <div class="col-12 col-md-6 col-xl-3 mb-3">
            <mat-card class="mt-2" style="height: 100%;">


                <mat-card-header class="chart-header">
                    <h4 class="chart-title">Weight Metrics</h4>

                    <div class="chart-header-action checkbox-list">
                        <mat-checkbox *ngFor="let task of subtasks" [(ngModel)]="task.completed" [color]="task.color"
                            (change)="OncheckBox(task)">
                            {{ task.name }}
                        </mat-checkbox>
                    </div>
                </mat-card-header>
                <div class="w-100 flex-grow-1 scroll-class" #chartWeightMatrix>
                    <ngx-charts-bar-vertical-stacked [scheme]="colorSchemeIntransit" [results]="WeightMatrixPush"
                        *ngIf="!ShowChargedWeight" [gradient]="false" [xAxis]="true" [yAxis]="true" [view]="[365, 295]"
                        [legend]="false" [showXAxisLabel]="false" [showYAxisLabel]="true"
                        [yAxisLabel]="'Weight (Tonnes)'" [showDataLabel]="true"
                        [xAxisTickFormatting]="xAxisTickFormatting">
                    </ngx-charts-bar-vertical-stacked>

                    <ngx-charts-bar-vertical-stacked [scheme]="colorSchemeIntransit" [results]="ChargedWeightMatrixPush"
                        *ngIf="ShowChargedWeight" [gradient]="false" [xAxis]="true" [yAxis]="true" [view]="[365, 295]"
                        [legend]="false" [showXAxisLabel]="false" [showYAxisLabel]="true"
                        [yAxisLabel]="'Weight (Tonnes)'" [showDataLabel]="true"
                        [xAxisTickFormatting]="xAxisTickFormatting">
                    </ngx-charts-bar-vertical-stacked>
                </div>
            </mat-card>
        </div> -->


    </div>

    <div class="card card-body mt-2">
        <div class="row mt-2">
            <div class="col">
                <div class="card border-0 box-shadow">
                    <div class="card-body widget-body">

                        <div class="row form-inline">

                            <div class="form-group col-xl-1 col-sm-6 col-12" style="color: black">
                                Filter By:
                            </div>

                            <div class="form-group col-xl-2 col-sm-6 col-12">
                                <mat-select placeholder="Filter by" style="width: 100%; border: 1px solid black"
                                    [(ngModel)]="filterBy" class="form-control">

                                    <mat-option value="booking">Booking Id</mat-option>
                                    <mat-option value="xpcn">XPCN No</mat-option>
                                    <mat-option value="service_type">Service Type</mat-option>

                                </mat-select>
                            </div>

                            <div class="form-group col-sm-3" *ngIf="filterBy !== 'asndate' && filterBy !== 'xpcndate'">

                                <div class="col-sm-3 form-group" style="color: black">
                                    Keyword:
                                </div>

                                <div class="col-sm-9">
                                    <input type="text" style="width: 90%; border: 1px solid black" [(ngModel)]="keyword"
                                        class="form-control" placeholder="Search by Keyword" (keyup.enter)="filter()">
                                </div>
                            </div>

                            <div class="form-group col-sm-3" *ngIf="filterBy === 'asndate' || filterBy === 'xpcndate'">

                                <div class="col-sm-3 form-group" style="color: black">
                                    Date:
                                </div>

                                <div class="col-sm-9">
                                    <div class="input-icon right">
                                        <input type="text" [(ngModel)]="keywordDate" class="form-control"
                                            style="min-width: 150px; margin-left: 10px" placeholder="Select Date"
                                            (keydown)="inputNotAllowed()" [owlDateTimeTrigger]="keywordDatePicker"
                                            [owlDateTime]="keywordDatePicker" name="keywordDate" readonly>

                                        <owl-date-time [pickerType]="'calendar'" #keywordDatePicker>
                                        </owl-date-time>
                                    </div>
                                </div>
                            </div>

                            <div class="form-group col-sm-3">
                                <button type="button" class="btn fa fa-search"
                                    style="background-color: #6e7dd2; color: #fff" (click)="filter()">
                                    <span> Search</span>
                                </button>

                                <button type="button" class="btn fa fa-eraser"
                                    style="margin-left: 10px; background-color: #37474f; color: #fff" (click)="clear()">
                                    <span> Clear</span>
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- SHIPMENT TABLE -->
    <div class="col-sm-12 mt-2 p-0 ml-0 mr-0">
        <div class="table table-responsive tbl-fixed div1">

            <table id="example3" class="table table-bordered text-center p-0 m-0" matSort>

                <thead class="tbl-head">
                    <tr class="tr-grid-header" style="background: #6e7dd2">
                        <th style="color: white; min-width: 80px">Sr. No</th>
                        <th style="color: white; min-width: 150px">Booking Date</th>
                        <th style="color: white; min-width: 150px">Booking Id</th>
                        <th style="color: white; min-width: 150px">XPCN</th>
                        <th style="color: white; min-width: 180px">Doc/LR/PO/ASN</th>
                        <th style="color: white; min-width: 150px">Order Type</th>
                        <th style="color: white; min-width: 150px">Origin</th>
                        <th style="color: white; min-width: 150px">Origin Postcode</th>
                        <th style="color: white; min-width: 150px">Origin State</th>
                        <th style="color: white; min-width: 150px">Destination</th>
                        <th style="color: white; min-width: 150px">Destination Postcode</th>
                        <th style="color: white; min-width: 150px">Destination State</th>
                        <th style="color: white; min-width: 150px">Picked Date</th>
                        <th style="color: white; min-width: 150px">Standard EDD</th>
                        <th style="color: white; min-width: 150px">Delivery Date</th>
                        <th style="color: white; min-width: 180px">Appointment Delivery</th>
                        <th style="color: white; min-width: 150px">Appointment Date</th>
                        <th style="color: white; min-width: 180px">Undelivered Reason</th>
                        <th style="color: white; min-width: 120px">Status</th>
                        <th style="color: white; min-width: 120px">Delivery Days</th>
                        <th style="color: white; min-width: 180px">Invoice Value(s)</th>
                        <th style="color: white; min-width: 180px">Consignor</th>
                        <th style="color: white; min-width: 180px">Consignee</th>
                        <th style="color: white; min-width: 180px">Brand Name</th>
                        <th style="color: white; min-width: 130px">Actual Weight</th>
                        <th style="color: white; min-width: 130px">Charged Weight</th>
                        <th style="color: white; min-width: 120px">Total Boxes</th>
                        <th style="color: white; min-width: 150px">Quantity/Pieces</th>
                        <th style="color: white; min-width: 130px">Serviceability</th>
                        <th style="color: white; min-width: 120px">POD Status</th>
                        <!-- <th style="color: white; min-width: 120px">Undelivery</th> -->
                        <th style="color: white; min-width: 120px">COD/DOD</th>
                        <th style="color: white; min-width: 150px">Payment Mode</th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let item of OrderList; let i = index">
                        <td>{{ startIndex + i }}</td>
                        <td>{{ item.BookingDate | date:'dd-MM-y' }}</td>
                        <td>{{ item.BookingNo }}</td>
                        <td>{{ item.XpcnNo }}</td>
                        <td>{{ item.PoLr }}</td>
                        <td>{{ item.OrderType }}</td>
                        <td>{{ item.Origin }}</td>
                        <td>{{ item.OriginPostcode }}</td>
                        <td>{{ item.OriginState }}</td>
                        <td>{{ item.Destination }}</td>
                        <td>{{ item.Destinationpostcode }}</td>
                        <td>{{ item.DestinationState }}</td>
                        <td>{{ item.PickedDate | date:'dd-MM-y' }}</td>
                        <td>{{ item.StandardEDD | date:'dd-MM-y' }}</td>
                        <td>{{ item.DeliveryDate | date:'dd-MM-y' }}</td>
                        <td>{{ item.AppointmentDeliveryMode }}</td>
                        <td>{{ item.AppointmentDate | date:'dd-MM-y' }}</td>
                        <td>{{ item.UndeliveredReason }}</td>
                        <td>{{ item.Status }}</td>
                        <td>{{ item.DeliveryDays }}</td>
                        <td>{{ item.InvoiceValue?.[0]?.dec_invoice_value }}</td>
                        <td>{{ item.ConsignorName }}</td>
                        <td>{{ item.ConsigneeName }}</td>
                        <td>{{ item.Brand }}</td>
                        <td>{{ item.ActualWeight }}</td>
                        <td>{{ item.charged_weight }}</td>
                        <td>{{ item.TotalBoxes }}</td>
                        <td>{{ item.QuantityPieces }}</td>
                        <td>{{ item.Serviceability }}</td>
                        <td>{{ item.PODStatus }}</td>
                        <!-- <td>{{ item.UnDelivery }}</td> -->
                        <td>{{ item.COD_DOD }}</td>
                        <td>{{ item.PaymentMode }}</td>
                    </tr>

                    <tr *ngIf="OrderList.length === 0">
                        <td class="text-center" colspan="100">
                            No Records Found
                        </td>
                    </tr>
                </tbody>

            </table>
        </div>
    </div>

    <!-- PAGINATION -->
    <mat-paginator [length]="totalSize" [pageIndex]="currentPage" [pageSize]="pageSize"
        [pageSizeOptions]="[5, 10, 25, 50, 100]" (page)="handlePage($event)" showFirstLastButtons>
    </mat-paginator>

</div>